// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__232Cw","errorLogs":"styles_errorLogs__fYdLg"};